import { StackedCellText } from '@/components/common/DataTable';
import { EmptyValue } from '@/components/common/EmptyValue';
import { getPlaceMapsLink } from '../utils/mapsLinks';
import { TextWithMapsLink } from './TextWithMapsLink';

interface VendorCellProps {
  vendor: string | null;
  lat: number | null;
  lon: number | null;
  travelRoute?: string | undefined;
}

export function VendorCell({ vendor, lat, lon, travelRoute }: VendorCellProps) {
  return (
    <StackedCellText
      primary={
        <TextWithMapsLink mapsLink={getPlaceMapsLink('Maps', { name: vendor, lat, lon })}>
          {vendor ?? <EmptyValue />}
        </TextWithMapsLink>
      }
      secondary={travelRoute}
    />
  );
}
